// extracted by mini-css-extract-plugin
export default {"search":"Search_search__oeODv","searchButton":"Search_searchButton__e8sY9"};